const I = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMjYuNjY2IDY0MCA0MjYuNjY2Ij4KICA8ZyBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS13aWR0aD0iMXB0Ij4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoNjQwdjQ4MEgweiIvPgogICAgPHBhdGggZmlsbD0iIzAwMjY3ZiIgZD0iTTAgMGgyMTMuM3Y0ODBIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNmMzE4MzAiIGQ9Ik00MjYuNyAwSDY0MHY0ODBINDI2Ljd6Ii8+CiAgPC9nPgo8L3N2Zz4K";
export {
  I as default
};
//# sourceMappingURL=PM-a4ac3c74.mjs.map
